import {WithdrawBlockReasonEnum} from '@/services/api-clients';

export function withdrawBlockReasonIconFilter(reason: WithdrawBlockReasonEnum): string {
  switch (reason) {
    case WithdrawBlockReasonEnum.Bailiff: return 'mdi-scale-unbalanced';
    case WithdrawBlockReasonEnum.MissingTaxQualification: return 'mdi-account-question';
    case WithdrawBlockReasonEnum.MissingFilesAfterRegistration: return 'mdi-file-alert';
    case WithdrawBlockReasonEnum.ExpiredStudentCard: return 'mdi-school';
    case WithdrawBlockReasonEnum.MissingSelfInvoicingPermission: return 'mdi-file-document-remove';
    case WithdrawBlockReasonEnum.Inactive: return 'mdi-account-off';
    case WithdrawBlockReasonEnum.OfficeDecision: return 'mdi-domain';
  }
}
